import { useAuth } from '@/context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';

export const useAdminAuth = () => {
  const { user, session, isLoading, userRole, roleLoading } = useAuth();
  const navigate = useNavigate();

  // Usar useMemo para evitar recalcular em cada render
  const isAdmin = useMemo(() => userRole === 'admin', [userRole]);
  const roleKnown = useMemo(() => (user ? userRole !== null : true), [user, userRole]);
  const combinedLoading = useMemo(
    () => isLoading || roleLoading || !roleKnown,
    [isLoading, roleLoading, roleKnown]
  );

  const redirectToLogin = () => {
    navigate('/login');
  };

  return {
    user,
    session,
    isAdmin,
    isLoading: combinedLoading,
    redirectToLogin,
  };
};